import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=2ec59d7c"
import script from "./EventList.ts?vue&type=script&lang=ts&external"
export * from "./EventList.ts?vue&type=script&lang=ts&external"
import style0 from "./EventList.vue?vue&type=style&index=0&id=2ec59d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports